"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tabs_exports = {};
__export(Tabs_exports, {
  Tabs: () => Tabs,
  default: () => Tabs_default
});
module.exports = __toCommonJS(Tabs_exports);
var import_bottom_tabs = require("@react-navigation/bottom-tabs");
var import_Protected = require("../views/Protected");
var import_nativeTabsOptions = require("./nativeTabsOptions");
var import_withLayoutContext = require("./withLayoutContext");
var BottomTabNavigator = (0, import_bottom_tabs.createBottomTabNavigator)().Navigator;
var RNTabs = (0, import_withLayoutContext.withLayoutContext)(BottomTabNavigator, import_nativeTabsOptions.processNativeTabsScreens);
var Tabs = Object.assign(RNTabs, {
  Protected: import_Protected.Protected,
  Screen: RNTabs.Screen
});
var Tabs_default = Tabs;
//# sourceMappingURL=Tabs.js.map
